const LocalizationService = {
  getCurrentLanguage: () => {
    return 'en_US'
  }
}

export default LocalizationService
